import $ from 'jquery'
import { createNamespacedHelpers } from 'vuex'

const { mapState, mapGetters } = createNamespacedHelpers('cache')

const NikanCache = {
  install(Vue, options) {
    Vue.mixin({
      computed: {
        ...mapState(['cache_objects']),
        ...mapGetters(['cache_items', 'cache_expiredItems', 'cache_get'])
      },
      methods: {
        cache_set(key, value, seconds) {
          var obj = { key, value, seconds }
          this.$store.dispatch('cache/set', obj)
        },
        cache_remove(key) {
          this.$store.dispatch('cache/remove', key)
        },
        cache_clear(pattern) {
          this.$store.dispatch('cache/clear', pattern)
        },

        cache_getOrSet(key, seconds, factory) {
          if (!$.isFunction(factory)) {
            throw new Error('factory needs to be function')
          }

          var _vm = this
          return new Promise((resolve, reject) => {
            var cached = this.cache_get(key)
            if (cached != null) {
              resolve(cached)
              return
            }

            var result = factory()
            if (result.then) {
              result
                .then(res => {
                  _vm.cache_set(key, res, seconds)
                  resolve(res)
                })
                .catch(error => {
                  reject(error)
                })
            } else {
              _vm.cache_set(key, result, seconds)
              resolve(result)
            }
          })
        }
      }
    })
  }
}

export default NikanCache
